import React from 'react';
import './Contact.css';
import logo from '../assets/logo.png';
import MainMenu from '../components/MainMenu';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';


const Contact = () => {
  return (
    <div className="contact-page">
     
  <div className="top-bar-wrapper">
  {/* Left: Ticker */}
  <div className="news-ticker">
    <div className="ticker-content">
      🎓 Admissions Open for 2025–2026 — Enroll Now at Universal Academy! 📢
    </div>
  </div>

  {/* Right: Location + Timing */}
   <div className="top-bar-info">
    <div className="top-item">
      <i className="fas fa-envelope"></i> universalacademy@gmail.com
    </div>
    <div className="top-item">
      <i className="fas fa-phone-alt"></i> 04368-221616
    </div>
    <div className="top-item">
      <i className="fas fa-map-marker-alt"></i> Neravy, Karaikal
    </div>
  
  </div>
</div>

	  
	<header className="logo-header">
  <div className="header-row">
    {/* Left: Logo */}
  <Link to="/" className="logo-area">
  <img src={logo} alt="Universal Academy Logo" />
</Link>
	
	{/* Title below logo+info */}
  <div className="school-title">
    <h1>UNIVERSAL ACADEMY</h1>
    <p>Affiliated to CBSE – Karaikal, Puducherry</p>
  </div>

    {/* Right: Contact Info */}
   
  </div>

  
</header>



<MainMenu />   

      {/* Hero Title */}
      <section className="contact-hero">
        <h1>Contact Us</h1>
        <p>We’d love to hear from you. Reach out to us using the details below or send a message directly.</p>
      </section>

      {/* Contact Info + Form */}
      <section className="contact-section">
        <div className="contact-container">
          {/* Left: Contact Info */}
        <div className="contact-info">
  <h2><i className="fas fa-map-marker-alt"></i> Visit Us</h2>
  <p>Universal Academy, Neravy, Karaikal<br />Puducherry 609604</p>

  <h2><i className="fas fa-envelope"></i> Email Us</h2>
  <p>
    <a href="mailto:universalacademy@gmail.com">universalacademy@gmail.com</a>
  </p>

  <h2><i className="fas fa-phone-alt"></i> Call Us</h2>
  <p>
    <a href="tel:+914368221616">04368-221616</a>
  </p>
</div>


          {/* Right: Contact Form */}
          <ContactForm/>
        </div>
      </section>

      {/* Google Map */}
      <section className="map-section">
        <iframe
          title="School Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3918.0179756866255!2d79.82828017586951!3d10.88623705715695!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5513f63e461ced%3A0x9db99ae4ae010e81!2sUniversal%20Acadamy%2CNeravi%2CKaraikal!5e0!3m2!1sen!2sin!4v1750824968377!5m2!1sen!2sin"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </section>

      {/* Footer */}
     <Footer /> 
    </div>
  );
};

export default Contact;
